import { createContext, useContext } from 'react';

interface SwitchedProviderContextValue {
    scheduleToken?: string;
    providerId?: number;
    onRefresh?: () => void;
    bordered?: boolean;
    // FormCard 报告自己是否处于编辑态（有未保存的改动），供外层 Save / Send 按钮拦截
    onEditingChange?: (cardTitle: string, editing: boolean, cardEl?: HTMLElement | null) => void;
}

const SwitchedProviderContext = createContext<SwitchedProviderContextValue>({});

export const useSwitchedProvider = () => useContext(SwitchedProviderContext);

export default SwitchedProviderContext;
